<div>
  <app-employee-list></app-employee-list>
  <app-employee-tabs
    [employee]="employeeService.employee | async"
    [currentUserEmployment]="employeeService.employment | async"
  ></app-employee-tabs>
</div>
